<div id="advantages-banner__slider-container" class="advantages-banner__container">
  <div class="container">
    <div #advSlider class="advantages-banner__slider keen-slider">
      @for (item of cards | slice: 0 : 4; track item) {
        <div
          class="keen-slider__slide advantages-banner__slide"
          [ngClass]="{ 'hide-slide': !isSliderActive, 'slide-visible': isVisibleSlide($index) }"
        >
          @if (item.type === 'modal') {
            <app-popover #popover [popOverTarget]="popOverParent">
              <div [innerHTML]="item.text"></div>
            </app-popover>
            <button
              [attr.aria-hidden]="!isVisibleSlide($index)"
              [tabIndex]="isVisibleSlide($index) ? 0 : -1"
              #popOverParent
              class="advantages-banner__slide-content"
              type="button"
              role="button"
              (click)="popover.openPopover()"
              (keypress)="popover.openPopover()"
            >
              <div class="advantages-banner__image" [ngStyle]="{ 'mask-image': 'url(' + item.icon + ')' }"></div>
              <div class="advantages-banner__title" [innerHTML]="item.title"></div>
            </button>
          }
          @if (item.type === 'link') {
            <a [href]="item.link" [attr.aria-hidden]="!isVisibleSlide($index)" [tabIndex]="isVisibleSlide($index) ? 0 : -1">
              <div class="advantages-banner__slide-content">
                <div class="advantages-banner__image" [ngStyle]="{ 'mask-image': 'url(' + item.icon + ')' }"></div>
                <div class="advantages-banner__title" [innerHTML]="item.title"></div>
              </div>
            </a>
          }
          @if (item.type === 'newsletter') {
            <a
              href="#"
              [attr.aria-hidden]="!isVisibleSlide($index)"
              [tabIndex]="isVisibleSlide($index) ? 0 : -1"
              (click)="clickOpenNewsletterModal($event)"
              (keypress)="clickOpenNewsletterModal($event)"
            >
              <div class="advantages-banner__slide-content">
                <div class="advantages-banner__image" [ngStyle]="{ 'mask-image': 'url(' + item.icon + ')' }"></div>
                <div class="advantages-banner__title" [innerHTML]="item.title"></div>
              </div>
            </a>
          }
        </div>
      }
    </div>
  </div>
</div>
